import React from 'react';
import IItemProps from './Items/IItemProps';
import IHasItemEventProps from './Items/IHasItemEventProps';
import mapItemToItemComponent from './Items/mapItemToItemComponent';
import IHasItemDataProps from './Items/IHasItemDataProps';
import IHasMetaDataModalProps from './Items/IHasMetaDataModalProps';
import { ICDV3ViewItem } from '../../ui-toolkit/cdItems/interfaces/ICDViewItem';

export const generateSectionItems = (items: ICDV3ViewItem[], props: IItemProps & IHasItemEventProps<ICDV3ViewItem>) =>
  items.map((item) => {
    const ItemComponent = mapItemToItemComponent(item) as React.ComponentType<
      IItemProps & IHasItemDataProps<ICDV3ViewItem> & IHasItemEventProps<ICDV3ViewItem> & IHasMetaDataModalProps
    >;
    return (
      <ItemComponent
        {...props}
        disableAutoExpand={!item.removable}
        key={item.id}
        data={item}
        showRemove={item.removable}
        showMove={item.movable}
      />
    );
  });
